"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortingFields = void 0;
exports.sortingFields = `
  direction
  fieldName
`;
//# sourceMappingURL=sorting.js.map